import React from 'react';
import '../../../../styles/global.css';
import './Diferenciais.css';

const Diferenciais = () => {
  // Function to scroll to the Nossa Estrutura section
  const scrollToEstrutura = (e) => {
    e.preventDefault();
    const estruturaSection = document.getElementById('nossa-estrutura');
    if (estruturaSection) {
      estruturaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Array of differentials with updated icons and titles
  const diferenciais = [
    {
      id: 1,
      icon: '👤', // Individual attention icon
      title: 'Atenção Individual',
      description: 'Educação de acordo com a necessidade de cada aluno.'
    },
    {
      id: 2,
      icon: '🌎', // Global/bilingual education icon
      title: 'Educação Bilíngue',
      description: 'Preparo para o mundo global.'
    },
    {
      id: 3,
      icon: '✝️', // Christian values icon
      title: 'Valores Cristãos',
      description: 'Formação ética e moral, com valores familiares.'
    },
    {
      id: 4,
      icon: '⏰', // Full-time schedule icon
      title: 'Horário Integral',
      description: 'Rotina de educação completa, com horários flexíveis.'
    },
    {
      id: 5,
      icon: '🎭', // Extracurricular activities icon
      title: 'Atividades Extracurriculares',
      description: 'Esportes, artes e cultura.'
    },
    {
      id: 6,
      icon: '🥗', // Healthy food icon
      title: 'Alimentação Saudável',
      description: 'Seleção de alimentos com critério de nutrição.'
    }
  ];

  return (
    <section id="diferenciais" className="diferenciais-section">
      <div className="container">
        <div className="diferenciais-grid">
          {diferenciais.map((item) => (
            <div key={item.id} className="diferencial-item">
              <div className="diferencial-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <a href="#nossa-estrutura" className="saber-mais" onClick={scrollToEstrutura}>
                Conheça de perto
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Diferenciais; 